import Dexie, { type Table } from "dexie";
export interface Device {
  id: string;
  token: string;
  name: string;
}
export interface LocalClip {
  id: string;
  stationId: string;
  mime: string;
  started: number;
  duration: number;
  finished: boolean;
  interrupted: boolean;
  detail: string;
  settings: Record<string, unknown>;
}
interface Chunk {
  clipId: string;
  seq: number;
  bytes: ArrayBuffer;
}
class CameraStore extends Dexie {
  devices!: Table<Device, string>;
  clips!: Table<LocalClip, string>;
  chunks!: Table<Chunk, [string, number]>;
  constructor() {
    super("kleda-camera-pilot");
    this.version(1).stores({
      devices: "id",
      clips: "id,stationId",
      chunks: "[clipId+seq],clipId",
    });
  }
}
export const cameraStore = new CameraStore();
export async function clipBlob(clip: LocalClip) {
  const chunks = await cameraStore.chunks
    .where("clipId")
    .equals(clip.id)
    .sortBy("seq");
  return new Blob(
    chunks.map((c) => c.bytes),
    { type: clip.mime },
  );
}
export async function removeUploaded(id: string) {
  await cameraStore.transaction(
    "rw",
    cameraStore.clips,
    cameraStore.chunks,
    async () => {
      await cameraStore.chunks.where("clipId").equals(id).delete();
      await cameraStore.clips.delete(id);
    },
  );
}
